import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IUserLanguage } from 'models/user/userlanguage';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { ILanguage } from 'models/common';
import { showPreloader } from 'modules/preloader';
import { IPreloaderAction } from 'models/preloader';
import { Button } from 'components';
import { PortalHeader } from 'components/PortalStructure';

interface IProps {
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	showPreloader?: (isVisible) => IPreloaderAction;
	t?: (key: string) => string;
	location?: any;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		showPreloader: (isVisible: boolean) => dispatch(showPreloader(isVisible)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ErrorPage404 extends React.Component<IProps, {}> {
	public componentDidMount() {
		this.props.showPreloader(false);
	}

	public render() {
		const { t } = this.props;

		return (
			<>
				<PortalHeader />
				<div className="errorPage">
					<div className="errorContent">
						<h2>
							<img src={require('containers/Html/images/e404.svg')} />
						</h2>
						<p>{t('ErrorPage404_ErrorLabel')}</p>
						<Button
							size="small"
							onClick={() => {
								history.go(-2);
							}}
						>
							{t('ErrorPage404_Home')}
						</Button>
					</div>
				</div>
			</>
		);
	}
}

export { ErrorPage404 };
